import styled from 'styled-components'

export const WorkbanchContainer = styled.div`
  * {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  min-width: 1280px;
  height: 100vh;
`

export const CustomPageContent = styled.div`
  display: flex;
  flex: 1;
  max-height: 100%;
  overflow: hidden;
`